import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async Thunk for OTP verification
export const verifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async (otp, { rejectWithValue }) => {
    try {
      const email = localStorage.getItem("userEmail"); // ✅ Get email from localStorage
      if (!email) {
        throw new Error("No email found. Please register again.");
      }

      const response = await axios.post("https://api.recdbase.org/auth/verifyAccount", {
        email, // ✅ Send saved email
        otp,   // ✅ Send OTP input
      });
        console.log(response.data);

      return response.data; // Assuming API returns success message or token
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "OTP verification failed");
    }
  }
);

// Resend OTP
export const resendOtp = createAsyncThunk(
  "otp/resend",
  async (email, { rejectWithValue }) => {
    try {
      const response = await axios.post("https://api.recdbase.org/auth/reset_opt", { email });
      return response.data.message; // Assuming the API returns a message
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to resend OTP");
    }
  }
);

const otpSlice = createSlice({
  name: "otp",
  initialState: {
    loading: false,
    success: "",
    errorMessage: "",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(verifyOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

      builder
      .addCase(resendOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(resendOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(resendOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default otpSlice.reducer;
